export const remainingDataItemId = '0';
